export default __webpack_public_path__ + "static/media/explore2_screenshot2.66071750.png";